import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalErrorModalService } from '../../services/global-error-modal.service';

@Component({
  selector: 'mpro-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent {
  constructor(public globalErrorModalService: GlobalErrorModalService) { }


  public onModalClose() {
    this.closeModal();
  }

  public closeModal(){
    this.globalErrorModalService.close();
  }
}
